<div class="page">
    <!-- Header -->
     <div class="content-wrapper">

       <!-- Sales Performance (hide when critical insights > 10) -->
       <div *ngIf="!shouldHideSalesPerformanceInMiddlePage()">
           <div class="section-header">SALES PERFORMANCE INSIGHTS</div>
           <div class="performance-section" *ngIf="salesPerformance?.byVolume?.length > 0 || salesPerformance?.bySqft?.length > 0">
               <div class="performance-label">COMPARING BY ESTIMATED SALES VOLUME</div>
               <div class="performance-row">
                   <div class="perf-item" *ngFor="let item of salesPerformance.byVolume">
                       <div class="perf-canvas">
                           <canvas width="40" height="40"
                                   [attr.data-percentile]="item.percentile"
                                   [attr.data-color]="item.color"
                                   class="mini-chart"></canvas>
                           <div class="perf-percentile">{{ item.percentile }}</div>
                       </div>
                       <div class="perf-text">
                           <div class="perf-prefix">This Store is a</div>
                           <div class="perf-title">{{ item.status }}</div>
                           <div class="perf-subtitle">{{ item.description }}</div>
                       </div>
                   </div>
               </div>
               <div class="no-data-message" *ngIf="!salesPerformance?.byVolume?.length">
               Performance cannot be analyzed due to this store missing required data
           </div>
               <div class="performance-label">COMPARING BY ESTIMATED SALES/SQFT</div>
               <div class="performance-row">
                   <div class="perf-item" *ngFor="let item of salesPerformance.bySqft">
                       <div class="perf-canvas">
                           <canvas width="40" height="40"
                                   [attr.data-percentile]="item.percentile"
                                   [attr.data-color]="item.color"
                                   class="mini-chart"></canvas>
                           <div class="perf-percentile">{{ item.percentile }}</div>
                       </div>
                       <div class="perf-text">
                           <div class="perf-prefix">This Store is a</div>
                           <div class="perf-title">{{ item.status }}</div>
                           <div class="perf-subtitle">{{ item.description }}</div>
                       </div>
                   </div>
               </div>
               <div class="no-data-message" *ngIf="!salesPerformance?.bySqft?.length">
               Performance cannot be analyzed due to this store missing required data
           </div>
           </div>

           <div class="no-data-message" *ngIf="!salesPerformance?.byVolume?.length && !salesPerformance?.bySqft?.length">
               Performance cannot be analyzed due to this store missing required data
           </div>
           
       </div>

       <!-- Additional Insights -->
       <div class="section-header">ADDITIONAL INSIGHTS</div>
       <div class="service-amenities-box" >
           <div class="info-row">
               <img src="assets/images/Image (4).png" class="info-icon">
               <div class="info-text">
                   <div class="info-title">{{ additionalInfo.servicesCount }} Services & Amenities</div>
                   <div class="info-desc">Offered at this location</div>
               </div>
               <!-- <div class="info-desc info-desc-inline">Services includes {{ additionalInfo.services }}</div> -->
           </div>
           <div class="tables-container">
           <table class="service-table">
               <thead>
                   <tr>
                       <th colspan="2">Services</th>
                   </tr>
               </thead>
               <tbody>
                 <tr *ngIf="!additionalInfo?.services?.length">
                   <td colspan="2">N/A</td>
                 </tr>
                 <tr *ngFor="let row of getServiceRows()">
                   <td>{{ row[0] || '' }}</td>
                   <td>{{ row[1] || '' }}</td>
                 </tr>
               </tbody>
           </table>

           <table class="amenities-table">
               <thead>
                   <tr>
                       <th [attr.colspan]="getAmenitiesColumns()">Amenities</th>
                   </tr>
               </thead>
               <tbody>
                 <tr *ngIf="!additionalInfo?.emenities?.length">
                   <td [attr.colspan]="getAmenitiesColumns()">N/A</td>
                 </tr>
                 <tr *ngFor="let row of getAmenitiesRows()">
                   <td *ngFor="let cell of row">{{ cell || '' }}</td>
                 </tr>
               </tbody>
           </table>
         </div>

       </div>
         <div>
      <div class="info-row">
              <img src="assets/images/Image (5).png" class="info-icon">
              <div class="info-text">
                  <div class="info-title">Analyst Ratings Available</div>
                  <div class="info-desc">{{ additionalInfo.analystRatingDate ? 'As of ' + additionalInfo.analystRatingDate : 'Not yet evaluated' }}</div>
              </div>
          </div>
          <div class="tables-container">
          <table>
              <thead>
                  <tr>
                      <th>Store Ratings</th>
                      <th class="rating-col"></th>
                      <th></th>
                      <th class="rating-col"></th>
                  </tr>
              </thead>
              <tbody>
                  <tr *ngFor="let row of storeRatings">
                      <td>{{ row[0].name }}</td>
                      <td class="rating-col">{{ row[0].rating }}</td>
                      <td>{{ row[1].name }}</td>
                      <td class="rating-col">{{ row[1].rating }}</td>
                  </tr>
              </tbody>
          </table>

          <table>
              <thead>
                  <tr>
                      <th>Parking Lot Ratings</th>
                      <th class="rating-col"></th>
                      <th></th>
                      <th class="rating-col"></th>
                  </tr>
              </thead>
              <tbody>
                  <tr *ngFor="let row of parkingLotRatings">
                      <td>{{ row[0].name }}</td>
                      <td class="rating-col">{{ row[0].rating }}</td>
                      <td>{{ row[1].name }}</td>
                      <td class="rating-col">{{ row[1].rating }}</td>
                  </tr>
                  <tr>
                      <td colspan="4" class="section-header-row">Cotenant Ratings</td>
                  </tr>
                  <tr *ngFor="let row of cotenantRatings">
                      <td>{{ row[0].name }}</td>
                      <td class="rating-col">{{ row[0].rating }}</td>
                      <td>{{ row[1].name }}</td>
                      <td class="rating-col">{{ row[1].rating }}</td>
                  </tr>
              </tbody>
          </table>
      </div>
    </div>

       <!-- Banner Analysis (show when sales performance is hidden) -->
       <div *ngIf="shouldHideSalesPerformanceInMiddlePage()" class="banner-analysis-section">
         <div class="banner-analysis-header">
           <div class="banner-analysis-info">
             <div class="banner-analysis-title-row">
               <div class="banner-analysis-title">BANNER ANALYSIS: {{ bannerAnalysis.banner }}</div>
             </div>
             <div class="banner-analysis-market">In the {{ bannerAnalysis.market }}</div>
             <div class="banner-analysis-description">Compare the entire banner's performance in the market. How does this store's banner compare to all other banners with a presence in the market?</div>
           </div>
         </div>
         <div class="banner-performance-row">
           <div class="banner-perf-item" *ngIf="bannerAnalysis.salesSqft">
             <div class="banner-perf-canvas">
               <canvas width="28" height="28"
                       [attr.data-percentile]="bannerAnalysis.salesSqft.percentile"
                       [attr.data-color]="bannerAnalysis.salesSqft.color"
                       class="banner-mini-chart"></canvas>
               <div class="banner-perf-percentile">{{ bannerAnalysis.salesSqft.percentile }}</div>
             </div>
             <div class="banner-perf-text">
               <div class="banner-perf-prefix">{{ bannerAnalysis.salesSqft.prefix }}</div>
               <div class="banner-perf-title">{{ bannerAnalysis.salesSqft.status }}</div>
               <div class="banner-perf-subtitle">{{ bannerAnalysis.salesSqft.description }}</div>
             </div>
           </div>

           <div class="banner-perf-item" *ngIf="bannerAnalysis.storeCount">
              <div class="banner-perf-canvas">
               <canvas width="28" height="28"
                       [attr.data-percentile]="bannerAnalysis.storeCount.percentile"
                       [attr.data-color]="bannerAnalysis.storeCount.color"
                       class="banner-mini-chart"></canvas>
               <div class="banner-perf-percentile">{{ bannerAnalysis.storeCount.percentile }}</div>
             </div>
             <div class="banner-perf-text">
               <div class="banner-perf-prefix">{{ bannerAnalysis.storeCount.prefix }}</div>
               <div class="banner-perf-title">{{ bannerAnalysis.storeCount.status }}</div>
               <div class="banner-perf-subtitle">{{ bannerAnalysis.storeCount.description }}</div>
             </div>
           </div>

           <div class="banner-perf-item" *ngIf="bannerAnalysis.salesVolume">
             <div class="banner-perf-canvas">
               <canvas width="28" height="28"
                       [attr.data-percentile]="bannerAnalysis.salesVolume.percentile"
                       [attr.data-color]="bannerAnalysis.salesVolume.color"
                       class="banner-mini-chart"></canvas>
               <div class="banner-perf-percentile">{{ bannerAnalysis.salesVolume.percentile }}</div>
             </div>
             <div class="banner-perf-text">
               <div class="banner-perf-prefix">{{ bannerAnalysis.salesVolume.prefix }}</div>
               <div class="banner-perf-title">{{ bannerAnalysis.salesVolume.status }}</div>
               <div class="banner-perf-subtitle">{{ bannerAnalysis.salesVolume.description }}</div>
             </div>
           </div>
         </div>
       </div>

       <div class="competitive-pattern-line">
           <div class="pattern-segment"></div>
           <div class="pattern-segment"></div>
     </div>

</div>
